// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"ni","result_page":"oi","what_are_calories":"pi","title":"qi","copy":"ri","chart":"si","to_reach":"ti","title_wrapper":"ui","rhode_percent":"vi","what_are_macro":"wi","text":"xi","img":"yi","macros_wrapper":"zi","macros":"Ai","macro_item":"Bi","value":"Ci","note":"Ei","btn":"Fi","carbo_item":"Gi","faq":"Hi","faq_items":"Ii"};
    if(module.hot) {
      // 1714654863310
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  